import type { RuntimeAssetPayload } from "../core/assets";
import type { CreatorVerificationProof, ReactiveWorldsMapPackage } from "../types";
export const RUNTIME_URL = "/runtime/reactive-worlds-v824.html?unified=1&catalog=device-art-v3&physics=carry-crates-explosives-v4&shell=editor-v3&audio=tactile-v2&stability=memory-share-v1&background=independent-v2&settings=compact-v1&controls=indicators-v2&terrain=shapes-v6&pump=gases-v1&materials=density-v2&jets=lava-v1&setup-kit=v1&ticket=v3&hoard-editor=v2&starter-hoard=v1&wardrobe=v1&gas-ignition=v1&ticket-layout=v6&lava=settled-v2&bucket=underwater-v1&editor-palette=mobile-v1&ladder=centre-v1&desktop-hud=v6&neighbor-previews=v5&keyboard-spill=v1&visitor-avatar=v1&hoard-copy=v1&hoard-toolbar=v4&share=modal-v3&editor-audio=toolbar-v1&audio-end=v1&water-audio=motion-v1&asset-help=v2&asset-scroll=v1&victory-audio=printer-v1";
export type RuntimeMode = "play" | "edit" | "home" | "character";
export interface RuntimeMessage {
  source?: string;
  type?: string;
  requestId?: string;
  package?: ReactiveWorldsMapPackage;
  proof?: CreatorVerificationProof | null;
  dataUrl?: string;
  message?: string;
  mapId?: string;
  profile?: Record<string, unknown>;
  reason?: string;
  path?: string;
  captureError?: string;
  pendingCapture?: boolean;
  active?: boolean;
  mode?: string;
}
export const requestId = (p = "req") =>
  `${p}_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 8)}`;
export function postRuntime(
  frame: HTMLIFrameElement,
  type: string,
  payload: Record<string, unknown> = {},
) {
  frame.contentWindow?.postMessage(
    { target: "reactive-worlds-runtime", type, ...payload },
    location.origin,
  );
}
export function loadRuntime(
  frame: HTMLIFrameElement,
  pkg: ReactiveWorldsMapPackage,
  mode: RuntimeMode,
  assets: RuntimeAssetPayload,
  mapId?: string,
  returnPath?: string,
  readOnlyProfile = false,
  creatorName?: string,
  bountyGold = 0,
) {
  const id = requestId("load");
  postRuntime(frame, "rw:load", {
    requestId: id,
    package: pkg,
    mode,
    assets,
    mapId,
    returnPath,
    readOnlyProfile,
    creatorName,
    bountyGold,
  });
  return id;
}
